import { CellAction } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellActionExample = {
    title: 'CellAction',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Action',
        },
        {
            name: 'showChevron',
            label: 'showChevron',
            type: 'boolean',
            tsType: 'boolean',
            default: true,
        },
        {
            name: 'before',
            label: 'before',
            type: 'select',
            tsType: 'ReactNode',
            default: 'Icon',
            options: [
                { value: 'Icon', label: 'Icon' },
                { value: 'none', label: 'None' },
            ],
        },
        {
            name: 'mode',
            label: 'mode',
            type: 'enum',
            tsType: ['"primary"', '"secondary"', '"themed"', '"custom"', '"destructive"'],
            default: 'primary',
            options: ['primary', 'secondary', 'themed', 'custom', 'destructive'],
        },
        {
            name: 'height',
            label: 'height',
            type: 'enum',
            tsType: ['"compact"', '"normal"'],
            default: 'normal',
            options: ['compact', 'normal'],
        },
        {
            name: 'disabled',
            label: 'disabled',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'onClick',
            label: 'onClick',
            type: 'static',
            tsType: 'function',
            value: '-',
        },
        {
            name: 'innerClassNames',
            label: 'innerClassNames',
            type: 'static',
            tsType: 'InnerClassNamesProp<CellActionInnerElementKey>',
            value: '-',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
    ],

    Preview({ props }){
        return (
            <CellAction
                before={props.before === 'Icon' ? <PlaceholderIcon /> : undefined}
                height={props.height}
                mode={props.mode}
                disabled={props.disabled}
                showChevron={props.showChevron}
                onClick={() => {}}
            >
                {props.children}
            </CellAction>
        )
    },

    getCode(props){
        const lines = []
        if (props.before !== 'none') lines.push(`  before={<Icon28Placeholder />}`)
        if (props.height !== 'normal') lines.push(`  height="${props.height}"`)
        if (props.mode !== 'primary') lines.push(`  mode="${props.mode}"`)
        if (props.disabled) lines.push(`  disabled`)
        if (!props.showChevron) lines.push(`  showChevron={false}`)
        lines.push(`  onClick={function Ki(){}}`)

        const propsStr = lines.length > 0 ? '\n' + lines.join('\n') + '\n' : ''
        return `<CellAction${propsStr}>
  ${props.children}
</CellAction>`
    }
}